import React from "react";

export const BuyYourTicketButton = () => (
    <div className="buy-ticket" style={{textAlign: 'center', fontSize: '2em'}}>
        <div className="title">Buy Your Ticket Here!</div>
        <a target="_blank" rel="noopener noreferrer" href={'https://www.filmon.com/checkout/buyOne?product_type=3&product_id=13&return_url=' + window.location.href} title={"Buy Now"}
           className="ui button small green w100" style={{fontSize: '8vw', lineHeight: '7vw'}}>Buy ticket! $14.95</a> <br/>
        <a target="_blank" rel="noopener noreferrer" href={'https://www.filmon.com/checkout/buyOne?product_type=3&product_id=13&return_url=' + window.location.href} title={"Buy Now"}>
            <span style={{display: "block", textAlign: 'right', fontSize: '20px', paddingRight: '20px'}}><sup>*</sup>Included in basic FilmOn subscription</span>
        </a>
    </div>
);
